<template>
  <vue-intro-step
    :key="Date.now()"
    v-model="showa"
    :config="config"
    @close="closeIntro"
  />
</template>

<script>
import VueIntroStep from './vue-intro-step'

export default {
  name: 'App',
  inject: ['showStart', 'toggleShowStart'],
  components: {
    VueIntroStep,
  },
  props: {
    show: Boolean,
    default: () => true,
  },
  computed: {
    showa: {
      get() {
        return this.show
      },
      set() {},
    },
  },
  data() {
    return {
      // show: false,
      config: {
        backgroundOpacity: 0.8,
        titleStyle: {
          textAlign: 'center',
          fontSize: '19px',
        },
        contentStyle: {
          textAlign: 'center',
          fontSize: '15px',
        },
        /**
         * nipponia-web-current-org
         *
         * nipponia-web-change-org
         *
         *
         */
        tips: [
          {
            el: '#nipponia-web-application-title',
            tipPosition: 'bottom',
            title: '欢迎使用' + '智匠云创平台客户端',
            content:
              '下面将带你熟悉系统的基本操作！点击【下一步】进行新手引导，点击【跳过】将关闭新手引导。',
            onNext: () => {
              return new Promise((resolve, reject) => {
                resolve(true)
              })
            },
          },

          {
            el: '#nipponia-web-refresh',
            tipPosition: 'bottom',
            title: '遇到问题？',
            content: '当遇到任何问题时，先不要慌，刷新系统后再进行相关操作！',
          },
          {
            el: '#nipponia-web-path',
            tipPosition: 'bottom',
            title: '当前位置',
            content: '当你进行相关的操作时，可获悉你当前操作的应用及其路径信息',
            onNext: () => {
              return Promise.resolve(true)
            },
          },
          {
            el: '#nipponia-web-user',
            tipPosition: 'left',
            title: '用户管理',
            content: '这里可以退出当前用户登录，从而切换其他用户',
            onNext: () => {
              return Promise.resolve(true)
            },
          },
          {
            el: '#nipponia-web-setting-more',
            tipPosition: 'left',
            title: '设置',
            content:
              '这里可以进行系统相关的设置，比如切换环境、更新客户端、关于系统（开启登陆密码的储存，选择系统打印机等信息）',
            onNext: () => {
              return Promise.resolve(true)
            },
          },
          {
            el: '#nipponia-web-start',
            tipPosition: 'top',
            title: '新手引导',
            content: '点击这里，再次打开新手引导',
          },
        ],
      },
    }
  },
  methods: {
    closeIntro() {
      // 不需要this.show = false，因为v-model会自动更新
      console.log('关闭')
      this.$emit('close', false)
    },
  },
}
</script>
